module.exports = __webpack_public_path__ + "img/members.0fbd56a0.svg";